import React from "react";
const RadioInput = ({ value, checked, onChange, setValue }) => {
    const onChangeHandler = (e) =>{
        onChange(e.target.innerText);
        setValue(e.target.innerText);
    }
    const onClickHandler = (e) => {
        onChange(e.target.innerText);
        setValue(e.target.innerText);
    }
    return (
        <div className="p-[8px] flex items-center radio-modal relative" >
            <input type="radio" checked={checked}  value={value} 
                onChange={onChangeHandler}/> 
            <label value={value} onClick={onClickHandler} 
                data-testid={`${value.replace(' ', '')}-btn`}
                className="text-base font-normal pl-[16px] cursor-pointer">
                {value}
            </label>
        </div>
    )
};
  
export default RadioInput;